const initialState = {
  requestingFetchProducts: false,
  successfulFetchProducts: false,
  errorFetchProducts: false,
  products: {},

  requestingFetchDownloadProducts: false,
  successfulFetchDownloadProducts: false,
  errorFetchDownloadProducts: false,

  requestingCreateProduct: false,
  successfulCreateProduct: false,
  errorsCreateProduct: false,
  upsertResult: null,

  requestingReadProduct: false,
  successfulReadProduct: false,
  errorsReadProduct: false,
  rowEdited: null,

  requestingDeleteProduct: false,
  successfulDeleteProduct: false,
  errorsDeleteProduct: false,
  rowDeleted: null,

  requestingUpdateProduct: false,
  successfulUpdateProduct: false,
  errorsUpdateProduct: false,
  rowUpdated: null,

  requestingDeleteSoftProduct: false,
  successfulDeleteSoftProduct: false,
  errorsDeleteSoftProduct: false,
  rowDeletedSoft: null,

  errorsUploadMassiveProductsFile: false,
  requestingUploadMassiveProductsFile: false,
  successfulUploadMassiveProductsFile: false,
  uploadedMassiveProductsFile: null,

};

const productReducer = (state = initialState, action) => {
  switch (action.type) {
    case "FETCH_PRODUCTS_REQUESTING":
      return {
        ...state,
        requestingFetchProducts: true,
        successfulFetchProducts: false,
        errorsFetchProducts: false,
      };
    case "FETCH_PRODUCT_SUCCESS":
      return {
        ...state,
        errorFetchProducts: false,
        requestingFetchProducts: false,
        successfulFetchProducts: true,
        products: action.value,
      };
    case "FETCH_PRODUCT_ERROR":
      return {
        ...state,
        errorFetchProducts: true,
        requestingFetchProducts: false,
        successfulFetchProducts: false,
      };
    case "FETCH_DOWNLOAD_PRODUCTS_REQUESTING":
      return {
        ...state,
        requestingFetchDownloadProducts: true,
        successfulFetchDownloadProducts: false,
        errorFetchDownloadProducts: false,
      };
    case "FETCH_DOWNLOAD_PRODUCT_SUCCESS":
      return {
        ...state,
        errorFetchDownloadProducts: false,
        requestingFetchDownloadProducts: false,
        successfulFetchDownloadProducts: true,
      };
    case "FETCH_DOWNLOAD_PRODUCT_ERROR":
      return {
        ...state,
        errorFetchDownloadProducts: true,
        requestingFetchDownloadProducts: false,
        successfulFetchDownloadProducts: false,
      };
    case "FETCH_DOWNLOAD_PRODUCT_RESET":
      return {
        ...state,
        errorFetchDownloadProducts: false,
        requestingFetchDownloadProducts: false,
        successfulFetchDownloadProducts: false,
      };
    case "CREATE_PRODUCT_REQUESTING":
      return {
        ...state,
        requestingCreateProduct: true,
        successfulCreateProduct: false,
        errorsCreateProduct: false,
        creationResult: null,
      };
    case "CREATE_PRODUCT_SUCCESS":
      return {
        ...state,
        errorsCreateProduct: false,
        requestingCreateProduct: false,
        successfulCreateProduct: true,
        upsertResult: action.value,
      };
    case "CREATE_PRODUCT_ERROR":
      return {
        ...state,
        errorsCreateProduct: action.value,
        requestingCreateProduct: false,
        successfulCreateProduct: false,
        upsertResult: action.value,
      };
    case "READ_PRODUCT_REQUESTING":
      return {
        ...state,
        requestingReadProduct: true,
        successfulReadProduct: false,
        errorsReadProduct: false,
      };
    case "READ_PRODUCT_SUCCESS":
      return {
        ...state,
        errorsReadProduct: false,
        requestingReadProduct: false,
        successfulReadProduct: true,
        rowEdited: action.value,
      };
    case "READ_PRODUCT_ERROR":
      return {
        ...state,
        errorsReadProduct: true,
        requestingReadProduct: false,
        successfulReadProduct: false,
      };
    case "DELETE_PRODUCT_REQUESTING":
      return {
        ...state,
        requestingDeleteProduct: true,
        successfulDeleteProduct: false,
        errorsDeleteProduct: false,
      };
    case "DELETE_PRODUCT_SUCCESS":
      return {
        ...state,
        errorsDeleteProduct: false,
        requestingDeleteProduct: false,
        successfulDeleteProduct: true,
        rowDeleted: action.value,
      };
    case "DELETE_PRODUCT_ERROR":
      return {
        ...state,
        errorsDeleteProduct: true,
        requestingDeleteProduct: false,
        successfulDeleteProduct: false,
      };
    case "UPDATE_PRODUCT_REQUESTING":
      return {
        ...state,
        requestingUpdateProduct: true,
        successfulUpdateProduct: false,
        errorsUpdateProduct: false,
        upsertResult: null,
      };
    case "UPDATE_PRODUCT_SUCCESS":
      return {
        ...state,
        errorsUpdateProduct: false,
        requestingUpdateProduct: false,
        successfulUpdateProduct: true,
        rowUpdated: action.value,
        upsertResult: action.value,
      };
    case "UPDATE_PRODUCT_ERROR":
      return {
        ...state,
        errorsUpdateProduct: true,
        requestingUpdateProduct: false,
        successfulUpdateProduct: false,
        upsertResult: action.value,
      };
    case "DELETE_SOFT_PRODUCT_REQUESTING":
      return {
        ...state,
        requestingDeleteSoftProduct: true,
        successfulDeleteSoftProduct: false,
        errorsDeleteSoftProduct: false,
      };
    case "DELETE_SOFT_PRODUCT_SUCCESS":
      return {
        ...state,
        errorsDeleteSoftProduct: false,
        requestingDeleteSoftProduct: false,
        successfulDeleteSoftProduct: true,
        rowDeletedSoft: action.value,
      };
    case "DELETE_SOFT_PRODUCT_ERROR":
      return {
        ...state,
        errorsDeleteSoftProduct: true,
        requestingDeleteSoftProduct: false,
        successfulDeleteSoftProduct: false,
      };
    case "RESET_PRODUCT_FORM":
      return {
        ...state,
        requestingCreateProduct: false,
        successfulCreateProduct: false,
        errorsCreateProduct: false,
        upsertResult: null,
        requestingReadProduct: false,
        successfulReadProduct: false,
        errorsReadProduct: false,
        rowEdited: null,
        requestingDeleteProduct: false,
        successfulDeleteProduct: false,
        rowDeleted: null,
        requestingUpdateProduct: false,
        successfulUpdateProduct: false,
        errorsUpdateProduct: false,
        rowUpdated: null,
        requestingDeleteSoftProduct: false,
        successfulDeleteSoftProduct: false,
        errorsDeleteSoftProduct: false,
        rowDeletedSoft: null,
      };
    case "RESET":
      return initialState;
    case "FETCH_PRODUCTS_BY_SHIPPER_REQUESTING":
      return {
        ...state,
        requestingFetchProductsByIdShipper: true,
        successfulFetchProductsByIdShipper: false,
        errorFetchProductsByIdShipper: false,
      };
    case "FETCH_PRODUCTS_BY_SHIPPER_SUCCESS":
      return {
        ...state,
        errorFetchProductsByIdShipper: false,
        requestingFetchProductsByIdShipper: false,
        successfulFetchProductsByIdShipper: true,
        productsByIdShipper: action.value,
      };
    case "FETCH_PRODUCTS_BY_SHIPPER_ERROR":
      return {
        ...state,
        errorFetchProductsByIdShipper: true,
        requestingFetchProductsByIdShipper: false,
        successfulFetchProductsByIdShipper: false,
      };
    case "RESET_PRODUCTS_BY_SHIPPER":
      return {
        ...state,
        productsByIdShipper: null,
      };
    case "UPLOAD_MASSIVE_PRODUCTS_FILE_REQUESTING":
      return {
        ...state,
        requestingUploadMassiveProductsFile: true,
        successfulUploadMassiveProductsFile: false,
        errorsUploadMassiveProductsFile: false,
      };
    case "UPLOAD_MASSIVE_PRODUCTS_FILE_SUCCESS":
      return {
        ...state,
        errorsUploadMassiveProductsFile: false,
        requestingUploadMassiveProductsFile: false,
        successfulUploadMassiveProductsFile: true,
        uploadedMassiveProductsFile: action.value,
      };
    case "UPLOAD_MASSIVE_PRODUCTS_FILE_ERROR":
      return {
        ...state,
        errorsUploadMassiveProductsFile: true,
        requestingUploadMassiveProductsFile: false,
        successfulUploadMassiveProductsFile: false,
      };
    case "UPLOAD_MASSIVE_PRODUCTS_FILE_RESET":
      return {
        ...state,
        errorsUploadMassiveProductsFile: false,
        requestingUploadMassiveProductsFile: false,
        successfulUploadMassiveProductsFile: false,
        uploadedMassiveProductsFile: null,
      };

    default:
      return state;
  }
};

export default productReducer;
